import React from 'react'
import HeaderContainer from './HeaderContainer'

const Header = () => <HeaderContainer data-test="component-header-index" />
export default Header
